export default __webpack_public_path__ + "static/media/setting.2cf00e4d.svg";